import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { ActorOwner } from '../../Models/Domains/Customers/ActorOwner';

declare var IS_RUNNING_IN_APP_POOL;

export class ActorOwnerClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(actorId: number): Promise<ActorOwner, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/ActorOwner/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { actorId: actorId }

    return AjaxWrapper.get<ActorOwner, any>(url, data);
  }
}

